import type { BankTransactionInput } from "@handvero/shared";

/** CAMT.052/053/054 (XML aus dem Online-Banking) in Umsätze umwandeln. */
export function bankFromCamt(xml: string): { transactions: BankTransactionInput[]; skipped: number } {
  const doc = new DOMParser().parseFromString(xml, "application/xml");
  if (doc.getElementsByTagName("parsererror").length) throw new Error("kein gültiges XML");
  const all = (root: Element | Document, name: string) => Array.from(root.getElementsByTagNameNS("*", name));
  const first = (root: Element | Document, name: string) => all(root, name)[0];
  const text = (root: Element | Document | undefined, name: string) => (root ? (first(root, name)?.textContent ?? "").trim() : "");
  const out: BankTransactionInput[] = [];
  let skipped = 0;
  for (const e of all(doc, "Ntry")) {
    const amount = Number(text(e, "Amt").replace(",", "."));
    const credit = text(e, "CdtDbtInd") === "CRDT";
    const booking = first(first(e, "BookgDt") ?? e, "Dt")?.textContent?.trim().slice(0, 10) ?? first(first(e, "ValDt") ?? e, "Dt")?.textContent?.trim().slice(0, 10);
    if (!Number.isFinite(amount) || amount === 0 || !booking || !/^\d{4}-\d{2}-\d{2}$/.test(booking)) {
      skipped++;
      continue;
    }
    const party = first(e, credit ? "Dbtr" : "Cdtr");
    const acct = first(e, credit ? "DbtrAcct" : "CdtrAcct");
    out.push({
      bookingDate: booking,
      amountCents: (credit ? 1 : -1) * Math.round(amount * 100),
      counterparty: text(party, "Nm") || null,
      iban: text(acct, "IBAN") || null,
      purpose: all(e, "Ustrd").map((u) => u.textContent?.trim()).filter(Boolean).join(" ") || text(e, "AddtlNtryInf") || null,
    });
  }
  return { transactions: out, skipped };
}
